/**
 * 교구 판(2026-11-03) — 조립 GLB 버전이 어느 자산 판인지("" 스마트 브릭 · "prime" 스파이크 프라임).
 *
 * <p>판은 놀이터 자산 매니페스트(공개 · /field-assets/manifest.json)에 GLB 버전마다 적혀 있다. 버전은 판마다 다르므로
 * 버전 하나로 판이 정해진다. 화면은 그 판으로 허브 이름을 고른다 — 스파이크 프라임 코스에서 '스마트 허브' 라고 부르지 않게.
 * 못 읽으면(오프라인 · 개발 서버 없음) 모두 스마트 브릭으로 본다 — 이름만 달라질 뿐 동작은 같다.
 */
import { useEffect, useState } from "react";

const MANIFEST = "/field-assets/manifest.json";
let cache: Promise<ReadonlyMap<string, string>> | null = null;

/** GLB 버전 → 판. 한 번만 읽는다(세션 동안). */
export function assetVariants(fetchFn: typeof fetch = fetch): Promise<ReadonlyMap<string, string>> {
  cache ??= fetchFn(MANIFEST)
    .then((r) => (r.ok ? r.json() : { models: [] }))
    .then((m: { models?: { glbVersion?: string; variant?: string }[] }) =>
      new Map((m.models ?? []).filter((x) => x.glbVersion).map((x) => [x.glbVersion as string, x.variant ?? ""])))
    .catch(() => new Map<string, string>());
  return cache;
}

/** 시험용 — 캐시를 비운다 */
export const resetAssetVariantsForTest = (): void => { cache = null; };

/** 자산 주소(…/campus-models/<slug>/<glbVersion>/…)에서 GLB 버전을 꺼낸다 */
export function glbVersionOfUrl(url: string | null | undefined): string | null {
  return url?.match(/\/campus-models\/[^/]+\/([0-9a-f]{8,})\//)?.[1] ?? null;
}

/** 판 표 — 처음엔 빈 표(= 스마트 브릭)로 그리고, 읽히면 다시 그린다 */
export function useAssetVariants(): ReadonlyMap<string, string> {
  const [m, setM] = useState<ReadonlyMap<string, string>>(() => new Map());
  useEffect(() => {
    let alive = true;
    void assetVariants().then((v) => { if (alive) setM(v); });
    return () => { alive = false; };
  }, []);
  return m;
}

/** 이 GLB 버전이 스파이크 프라임 판인가 */
export function usePrimeHub(glbVersion: string | null | undefined): boolean {
  const m = useAssetVariants();
  return !!glbVersion && m.get(glbVersion) === "prime";
}
